export enum EStatusLoteEnum {
  CRIADO = "Criado",
  EM_VALIDACAO = "Processando planilha", // Lote em processamento
  ABERTO = "Em aberto", // Lote validado, cadastrado e aberto para revisão
  AGENDADO = "Agendado", // nao usado por enquanto
  EM_EXECUCAO = "Em execução", // nao usado por enquanto
  AGUARDANDO_PROCESSAMENTO = "Processando pagamento", // usuário conferiu e solicitou os cartões
  EM_PROCESSAMENTO = "Processando pagamento",
  FINALIZADO = "Pago",
  CANCELADO = "Cancelado",
  ERRO = "Carga com erro", // Lote com erro em todos os itens
}

const CommonStatusMap = {
  emAberto: { label: 'Em aberto', color: '#333333' },
  processando: { label: 'Processando planilha', color: '#EEB03D' },
  cancelado: { label: 'Cancelado', color: '#757474' },
  erro: { label: 'Carga com erro', color: '#DC3645' },
};

export const StatusLoteMap = {
  ['CRIADO']: CommonStatusMap.emAberto,
  ['ABERTO']: CommonStatusMap.emAberto,
  ['EM_VALIDACAO']: CommonStatusMap.processando,
  ['EM_EXECUCAO']: CommonStatusMap.processando,
  ['EM_PROCESSAMENTO']: CommonStatusMap.processando,
  ['AGUARDANDO_PROCESSAMENTO']: { label: 'Aguardando processamento', color: CommonStatusMap.processando.color },
  ['AGENDADO']: { label: 'Agendado', color: '#3772FF' },
  ['FINALIZADO']: { label: 'Pago', color: '#05A660' },
  ['CANCELADO']: CommonStatusMap.cancelado,
  ['ERRO']: CommonStatusMap.erro,
};
